import Section, { SectionPanels, Panel } from './Section'
import styled from 'styled-components'
import { t, tStr } from '@utils/lang'

const TestimonialSection = styled(Section)`
  ul li {
    color: var(--themeColorBetaSecondary);
  }
`
const Name = styled.div`
  margin-top: 28px;
  color: var(--themeColorBetaBrandHeader);
  font-size: var(--themeFontSizeH4);
  font-weight: var(--themeFontWeightBold);
  line-height: var(--themeFontLineHeight);
`
const Date = styled.div`
  font-size: var(--themeFontSizeBody);
`

const Testimonials = () => (
  <TestimonialSection title={tStr('testimonialsTitle_s')} tagLine={tStr('testimonialsTagLine_s')}>
    <SectionPanels>
      <Panel>
        <div>{t('testimonial1Quote_s')}</div>
        <Name>Natasha G.</Name>
        <Date>{t('testimonialRunningSince_s', { year: 2018 })}</Date>
      </Panel>
      <Panel>
        <div>{t('testimonial2Quote_s')}</div>
        <Name>Jessica S.</Name>
        <Date>{t('testimonialRunningSince_s', { year: 2020 })}</Date>
      </Panel>
      <Panel>
        <div>{t('testimonial3Quote_s')}</div>
        <Name>Omar C.</Name>
        <Date>{t('testimonialRunningSince_s', { year: 2022 })}</Date>
      </Panel>
    </SectionPanels>
  </TestimonialSection>
)
export default Testimonials
